export default {
	required: "Ce champ est obligatoire",
	email: "Format d'e-mail invalide",
	minLength: "Le champ {field} doit comporter au moins {min} caractères",
	maxLength: "Le champ doit comporter au maximum {max} caractères",
	passwordMismatch: "Les mots de passe ne correspondent pas",
	requiredField: "Le champ {field} est obligatoire",
	cpfDigits: "Le CPF doit comporter 11 chiffres",
	cpfInvalid: "CPF invalide — vérifiez les chiffres",
	zipCodeDigits: "Le code postal doit comporter 8 chiffres",
	invalidPhone: "Numéro de téléphone invalide",
};
